import { useAuthSession } from '../hooks';

import { AuthContext } from './auth-context';

// ----------------------------------------------------------------------

export function AuthContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const authSession = useAuthSession();

  return (
    <AuthContext.Provider value={authSession}>{children}</AuthContext.Provider>
  );
}
